export default __webpack_public_path__ + "static/media/navigation-Header-Tablet.600a301c.jpg";